
import { useEffect, useState } from "react";
import { getLeadsApi } from "../apiServices/fbLeadgenServices";

const useFbLeads = (params) => {
  const [leads, setLeads] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchLeads = async () => {
    try {
      setLoading(true);

      const res = await getLeadsApi(params);

      const data = res?.data;

      setLeads(data?.leads || []);
      setPagination({
        page: data?.page || 1,
        totalPages: data?.totalPages || 1,
        total: data?.total || 0,
        activeCount: data?.activeCount || 0,
        archivedCount: data?.archivedCount || 0,
        totalAll: data?.totalAll || 0,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchLeads();
    }, 400);

    return () => clearTimeout(delay);
  }, [JSON.stringify(params)]);

  return { leads, pagination, loading, fetchLeads };
};

export default useFbLeads;